import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import numeral from 'numeral';
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import { amber } from '@mui/material/colors';
import json2mq from 'json2mq';
import useMediaQuery from '@mui/material/useMediaQuery';
import CurrencyFormatter from 'currency-formatter-react'

const ExpenseListItem = (props) => {

    const navigate = useNavigate();
    const primary = amber[500];

    const mDevice = useMediaQuery(json2mq({
        maxWidth: 600
    }),
    );

    return (
        <tr>
            <td className='expense-data'>
                <h1>{props.expense.description}</h1>
                <h3>{moment(props.expense.createdAt).format('MMMM Do, YYYY')}</h3>
                <p>{props.expense.note}</p>
            </td>

            {mDevice ?
                <td className='expense-amount-td'>
                    <h3 className='expense-amount'>
                        {/* {numeral(props.expense.amount).format('$0,0.00')} */}
                        <CurrencyFormatter
                            value={Number(props.expense.amount).toFixed(2)}
                            currency='INR'
                            thousandSeparator={false}
                            isFloat={true}
                        />
                    </h3>
                    <Fab
                        className='edit-button'
                        style={{
                            backgroundColor: primary
                        }}
                        aria-label="edit"
                        onClick={() => {
                            navigate(`/edit/${props.expense.id}`);
                        }}
                    >
                        <EditIcon />
                    </Fab>
                </td>
                :

                <>
                    <td>
                        <h3 className='expense-amount'>
                            {/* {numeral(props.expense.amount).format('$0,0.00')} */}
                            <CurrencyFormatter
                                value={Number(props.expense.amount).toFixed(2)}
                                currency='INR'
                                thousandSeparator={false}
                                isFloat={true}
                            />
                        </h3>
                    </td>

                    <td>
                        <Fab
                            className='edit-button'
                            style={{
                                backgroundColor: primary
                            }}
                            aria-label="edit"
                            onClick={() => {
                                navigate(`/edit/${props.expense.id}`);
                            }}
                        >
                            <EditIcon />
                        </Fab>
                    </td>
                </>
            }
        </tr>
    );
};

export default ExpenseListItem;